var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-pill badge-primary w-70",class:_vm.statusClass},[_vm._v("\n\t"+_vm._s(_vm.statusTranslation)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }